import { Component, Injector, inject } from "@angular/core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { FilterDataType, MatTableCrudComponent } from "../../../shared/components/mat-table-crud/mat-table-crud.component";
import { MatTableCrudService } from "../../../shared/components/mat-table-crud/mat-table-crud.service";
import { AuthorisationService } from "../../../shared/services/authorisation.service";
import { ConfigurationService } from "../../../shared/services/configuration.service";
import { DayPart } from "../administration.models";
import { AdministrationService } from '../administration.service';
import { DayPartEditComponent } from "./daypart-edit.component";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { QueryClient } from "@tanstack/angular-query-experimental";
import { Subscription } from "rxjs";


@Component({
  templateUrl: './dayparts.component.html',
  styleUrls: ['./dayparts.component.scss', '../../../shared/components/mat-table-crud/mat-table-crud.component.scss'],
  providers: [MatTableCrudService],
  standalone: true,
  imports: [MatCardModule, MatButtonModule, MatIconModule, MatTableModule, MatSortModule, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatPaginatorModule]
})
export class DayPartsComponent extends MatTableCrudComponent<DayPart>
{
  public DayPartNameFilter: any;
  public DayPartLabelFilter: any;

  private queryClient = inject(QueryClient);

  private onDataFetchedSubscription: Subscription;
  constructor(public authorisationService: AuthorisationService, protected injector: Injector, public configurationService: ConfigurationService, public administrationService: AdministrationService)
  {
    super(injector,
      DayPartEditComponent,
      DayPartEditComponent,
      DayPartEditComponent,
      "CreateDayPart",
      "DeleteDayPart",
      "GetDayParts",
      "UpdateDayPart",
      configurationService.cbSettings().adminServiceUrl,
      configurationService.cbSettings().adminServiceUrl,
      configurationService.cbSettings().adminServiceUrl,
      configurationService.cbSettings().adminServiceUrl);

    this.changedByField = "ChangedByUserId";

    this.displayedColumns = ['Id', 'DayPartName', 'DayPartLabel'];
    this.filteredValues = [{ Field: "DayPartName", Value: "", Path: "", DataType: FilterDataType.String }, { Field: "DayPartLabel", Value: "", Path: "", DataType: FilterDataType.String }];

    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.hasBackdrop = true;
    this.dialogConfig.width = "24rem";

    this.CanAdd = this.authorisationService.hasPermission(this.authorisationService.Permissions.AddDayParts);
    this.CanEdit = this.authorisationService.hasPermission(this.authorisationService.Permissions.EditDayParts);
    this.CanDelete = this.authorisationService.hasPermission(this.authorisationService.Permissions.DeleteDayParts);
  }

  ngOnInit(): void
  {
    super.ngOnInit();

    this.onDataFetchedSubscription = this.mtCrudService.OnDataFetched.subscribe((result: any) =>
    {
      this.queryClient.invalidateQueries({
        type: "all", exact: false, predicate: (query: any) =>
        {
          return query.queryKey[0] == "DayParts";
        }
      });
    });
  }

  addNew(event: any)
  {
    this.addedItem.SortOrder = 0;

    super.addNew(event);
  }

  deleteItem(event: any, dayPart: DayPart)
  {
    this.deleteConfirmationMessage = `Are you sure you want to delete this day part (${dayPart.DayPartName})?`;
    this.deleteHeaderText = "Delete Day Part?";

    super.deleteItem(event, dayPart);
  }



  ngOnDestroy()
  {
    // prevent memory leak when component destroyed
    if (this.onDataFetchedSubscription)
    {
      this.onDataFetchedSubscription.unsubscribe();
    }

    super.ngOnDestroy();
  }











}

